/* Últimos vistos (paridad MX, tarea B4).
   - Registro: si la página tiene [data-tbl-viewed-handle] (el <product-form> de
     la PDP), ese handle pasa al frente de localStorage.tbl_recently_viewed
     (máx. 8 handles).
   - Render: cada [data-recently-viewed] pide /products/<handle>.js por cada
     handle guardado (menos data-exclude), pinta tarjetas simples y quita
     `hidden` si hay al menos una. Los fetch fallidos (producto despublicado)
     se ignoran en silencio.
   - Precio: se usa shop.money_format (data-money-format, p. ej. "Q{{amount}}")
     para coincidir con el formato que imprime Liquid: Q1,899.00. */
(() => {
  if (window.__tblRecentlyViewedInit) return;
  window.__tblRecentlyViewedInit = true;

  const KEY = 'tbl_recently_viewed';
  const MAX = 8;

  const leer = () => {
    try {
      const lista = JSON.parse(window.localStorage.getItem(KEY) || '[]');
      return Array.isArray(lista) ? lista.filter((h) => typeof h === 'string' && h) : [];
    } catch {
      return [];
    }
  };

  const guardar = (lista) => {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(lista.slice(0, MAX)));
    } catch {
      /* almacenamiento no disponible (modo privado, cuota): se sigue sin registrar */
    }
  };

  const registrar = (handle) => {
    if (!handle) return;
    const lista = leer().filter((h) => h !== handle);
    lista.unshift(handle);
    guardar(lista);
  };

  const formatearNumero = (cents, decimales, milesComa) => {
    const n = (cents / 100).toFixed(decimales);
    const [entero, dec] = n.split('.');
    const enteroSep = entero.replace(/\B(?=(\d{3})+(?!\d))/g, milesComa ? ',' : '.');
    if (!dec) return enteroSep;
    return enteroSep + (milesComa ? '.' : ',') + dec;
  };

  const dinero = (cents, formato) => {
    const plantilla = (formato && formato.includes('{{') ? formato : 'Q{{amount}}').replace(/<[^>]*>/g, '');
    return plantilla.replace(/\{\{\s*(\w+)\s*\}\}/g, (_, tipo) => {
      switch (tipo) {
        case 'amount_no_decimals':
          return formatearNumero(cents, 0, true);
        case 'amount_with_comma_separator':
          return formatearNumero(cents, 2, false);
        case 'amount_no_decimals_with_comma_separator':
          return formatearNumero(cents, 0, false);
        default:
          return formatearNumero(cents, 2, true);
      }
    });
  };

  const imagen = (url, ancho) => {
    if (!url) return '';
    return url + (url.includes('?') ? '&' : '?') + 'width=' + ancho;
  };

  const tarjeta = (p, formato) => {
    const li = document.createElement('li');
    li.className = 'tbl-vistos__item';
    const a = document.createElement('a');
    a.className = 'tbl-vistos__link';
    a.href = p.url;
    const src = p.featured_image || (p.images && p.images[0]) || '';
    if (src) {
      const img = document.createElement('img');
      img.className = 'tbl-vistos__img';
      img.loading = 'lazy';
      img.width = 300;
      img.height = 300;
      img.alt = p.title || '';
      img.src = imagen(src, 300);
      img.srcset = imagen(src, 300) + ' 300w, ' + imagen(src, 600) + ' 600w';
      img.sizes = '(min-width: 990px) 20vw, 45vw';
      a.appendChild(img);
    } else {
      const ph = document.createElement('span');
      ph.className = 'tbl-vistos__img tbl-vistos__img--empty';
      a.appendChild(ph);
    }
    const titulo = document.createElement('span');
    titulo.className = 'tbl-vistos__title';
    titulo.textContent = p.title || '';
    const precio = document.createElement('span');
    precio.className = 'tbl-vistos__price';
    precio.textContent = dinero(p.price, formato);
    a.appendChild(titulo);
    a.appendChild(precio);
    li.appendChild(a);
    return li;
  };

  const pintar = (root) => {
    const excluir = root.dataset.exclude || '';
    const formato = root.dataset.moneyFormat || '';
    const lista = root.querySelector('.tbl-vistos__list');
    const handles = leer().filter((h) => h !== excluir);
    if (!lista || !handles.length) return;

    Promise.allSettled(
      handles.map((h) =>
        fetch('/products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } }).then((r) =>
          r.ok ? r.json() : Promise.reject(new Error(String(r.status)))
        )
      )
    ).then((resultados) => {
      const frag = document.createDocumentFragment();
      let n = 0;
      resultados.forEach((res) => {
        if (res.status !== 'fulfilled' || !res.value || !res.value.url) return;
        frag.appendChild(tarjeta(res.value, formato));
        n += 1;
      });
      if (!n) return;
      lista.replaceChildren(frag);
      root.hidden = false;
    });
  };

  const init = () => {
    const actual = document.querySelector('[data-tbl-viewed-handle]');
    if (actual) registrar(actual.dataset.tblViewedHandle);
    document.querySelectorAll('[data-recently-viewed]').forEach(pintar);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
